export default __webpack_public_path__ + "static/media/verify_email.e56f31b8.svg";